// This is used to track DOM elements that represent ui-assignee / ui-assignee-avatar components,
// so that we can refresh them on change manually
export const AssigneeComponentInstances = new Map<HTMLElement, { assigneeIds: string[]; refresh(): void }>();
